import React, { useState } from 'react';
import { Button } from './ui/button';
import { Trash2, Loader2 } from 'lucide-react';
import {
  AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription,
  AlertDialogFooter, AlertDialogCancel, AlertDialogAction,
} from './ui/alert-dialog';

/* Botón "Eliminar" con confirmación, reutilizado por los diálogos de evento/reunión/tarea. */
export const DeleteEventButton = ({ title, description, onConfirm, deleting, testId = 'delete-event-btn' }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button type="button" variant="outline" className="text-red-600 border-red-200 hover:bg-red-50 hover:text-red-700 mr-auto" onClick={() => setOpen(true)} disabled={deleting} data-testid={testId}>
        {deleting ? <Loader2 className="w-4 h-4 animate-spin" /> : <><Trash2 className="w-4 h-4 mr-1.5" /> Eliminar</>}
      </Button>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent data-testid="delete-confirm-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>¿Eliminar «{title || 'Sin título'}»?</AlertDialogTitle>
            <AlertDialogDescription>{description}</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="delete-cancel-btn">Cancelar</AlertDialogCancel>
            <AlertDialogAction className="bg-red-600 hover:bg-red-700" onClick={() => { setOpen(false); onConfirm(); }} data-testid="delete-confirm-btn">
              <Trash2 className="w-4 h-4 mr-1.5" /> Sí, eliminar
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
